import { RunFastIcon } from './RunFastIcon';

/**
 * author: Austin Andrews
 * id D541EB73-227A-419B-A5F7-7242EB02D916
 * name run-fast
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/run-fast.svg
 * tags
 * - Home Automation 
 * - Sport 
 * - People / Family 
 */
export const HumanRunFastIcon = RunFastIcon;
export default HumanRunFastIcon